$(window).on('load resize', function() {
  enquire.register('screen and (max-width: 767px)', {
    match: function() {
      $('.append-to--collapse-seibu-resort').appendTo(
        '#collapse-seibu-resort > .d-flex'
      )
      $('.append-to--collapse-seibu-group').appendTo(
        '#collapse-seibu-group > .d-flex'
      )
    }
  })
  enquire.register('screen and (min-width: 768px)', {
    match: function() {
      $('.append-to--collapse-seibu-resort').appendTo(
        '.footer__links-external__wrapper'
      )
      $('.append-to--collapse-seibu-group').appendTo(
        '.footer__links-external__logo-wrapper'
      )
    }
  })
})
